module.exports = __webpack_public_path__ + "img/test.1ac9cb8b.jpg";